
/**
 * @description
 * 로드맵 > 각 상세 페이지
 */

import { ADD_FAVORITE_ROADMAP } from '@/utils/amplitudeEvent/amplitudeEvents.js';
import { getLastClickSection } from '@/utils/localStorageUtils.js';
import { getPathAt } from '@/utils/path';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import CourseDescription from '@/components/course/description/CourseDescription.vue';
import WhatIsDifferent from '@/components/course/different/WhatIsDifferent.vue';
import CourseNavigator from '@/components/course/navigator/CourseNavigator.vue';
import CourseRelatedClass from '@/components/course/related-class/CourseRelatedClass.vue';
import CourseSummary from '@/components/course/summary/CourseSummary.vue';
import CourseThumbnail from '@/components/course/thumbnail/CourseThumbnail.vue';

export default {
  name: 'CourseId',
  components: {
    CourseThumbnail,
    CourseSummary,
    CourseNavigator,
    CourseDescription,
    CourseRelatedClass,
    WhatIsDifferent,
  },
  data() {
    return {
      isPending: false,
    };
  },
  computed: {
    ...mapGetters('course', [
      'id',
      'favoriteCourseObj',
      'title',
      'category',
      'classes',
    ]),
    ...mapGetters('user/favorite', ['favoriteCourseIds']),
    ...mapGetters('config', ['roadmapPopup']),
    isFavoriteCourse: ({ favoriteCourseIds, id }) =>
      favoriteCourseIds.includes(id),
  },
  mounted() {
    this.removeOverflowStyle();

    // 팝업 이벤트 호출
    this.showFlareLaneInApp(this.roadmapPopup);
  },
  destroyed() {
    this.restoreOverflowStyle();
  },
  methods: {
    ...mapMutations({
      increaseCourseFavoriteCount: 'course/INCREASE_FAVORITE_COUNT',
      decreaseCourseFavoriteCount: 'course/DECREASE_FAVORITE_COUNT',
      addFavoriteCourse: 'user/favorite/ADD_FAVORITE_COURSE_PRODUCT',
      removeFavoriteCourse: 'user/favorite/REMOVE_FAVORITE_COURSE_PRODUCT',
    }),
    ...mapActions('user/favorite', [
      'createCourseFavorite',
      'deleteCourseFavorite',
    ]),
    removeOverflowStyle() {
      document.body.style.overflowX = 'unset';
    },
    restoreOverflowStyle() {
      document.body.style.overflowX = 'hidden';
    },
    async onClickFavorite() {
      // 비로그인 유저는 로그인 모달 열고 얼리리턴
      if (!this.$auth.loggedIn) {
        this.requestToken({});
        return;
      }

      if (this.isPending) return;

      try {
        this.isPending = true;

        if (this.isFavoriteCourse) {
          await this.deleteCourseFavorite({ courseId: this.id });
          this.removeFavoriteCourse({ courseId: this.id });

          // 찜하기 카운트 --
          this.decreaseCourseFavoriteCount();
        } else {
          await this.createCourseFavorite({ courseId: this.id });
          this.addFavoriteCourse({
            courseId: this.id,
            course: this.favoriteCourseObj,
          });

          // 찜하기 카운트 ++
          this.increaseCourseFavoriteCount();

          // 찜하기 로깅
          this.logCourseFavorite();

          this.$toast.open({
            message:
              '<p class="font-caption-bold">찜한 로드맵에 추가되었어요.</p>',
            type: 'default',
            duration: 2000,
          });
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isPending = false;
      }
    },
    logCourseFavorite() {
      this.logUserCustomEvent(ADD_FAVORITE_ROADMAP, {
        roadmap_id: this.id,
        roadmap_name: this.title,
        roadmap_category_name: this.category?.parentName,
        at: getPathAt(this.$route),
        section: getLastClickSection(),
        is_participate:
          this.classes?.filter(c => c.isPurchased === true).length > 0,
        component: 'detail_page',
      });
    },
  },
};
